export default __webpack_public_path__ + "static/media/card-icon.5ddd98a0.svg";